<template>
  <div>
    <!-- BANNER -->
    <div class="banner">
      <div class="banner-overlay box-overlay brand_tonic_bg rounded-top-10">
        <img v-lazy="localImg(banner)" class="img img-luminous" />
      </div>
      <img v-lazy="localImg(display_img)" class="display-img" />
    </div>

    <!-- WELCOME BLOCK -->
    <div
      class="welcome-block w-100 d-flex flex-column justify-content-start align-items-center"
    >
      <div class="welcome-title font-weight-bold brand_navy">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Live Classes & Recordings</template
        >
        <template v-if="account_type === 'parent'"
          >Just In-time Video Lessons</template
        >
      </div>

      <div class="welcome-text color_grey_dark text-center">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Set up live video meetings with students so they can attend class
          from anywhere</template
        >
        <template v-if="account_type === 'parent'"
          >Just when they need to catch up on a difficult concept, there is an
          interactive video to the rescue</template
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogThree",

  props: ["banner", "display_img"],

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },
};
</script>

<style>
</style>
